export const STORED_ACCESS_TOKEN = '@ACCESS_TOKEN'
export const STORED_REFRESH_TOKEN = '@REFRESH_TOKEN'
export const IS_EDIT = 'IS_EDIT'
export const FROM_ANOTHER_WEB = 'FROM_ANOTHER_WEB'
